// src/LoginPage.js
import React, { useState } from 'react';
import { useAuth } from './AuthContext'; // (1. Import useAuth)
import { useNavigate, Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  // (2. ดึงฟังก์ชัน login และ isAuthenticated จาก Context)
  const { login, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();

  // (ถ้า Login อยู่แล้ว ให้เด้งไปหน้า Admin)
  if (isAuthenticated) {
    // ถ้า Login อยู่แล้ว ให้เด้งตาม Role
    return <Navigate to={user.role === 'admin' ? '/admin' : '/'} replace />;
  }

  // (3. สร้าง handleSubmit ที่ยิง API ผ่าน Context)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error('กรุณากรอก Username และ Password');
      return;
    }
    
    setIsLoading(true);
    
    // (4. (สำคัญ) เรียกฟังก์ชัน login จาก AuthContext)
    // (ฟังก์ชันนี้จะยิง API, แสดง toast, และเก็บ Token เอง)
    // (1. รับ "ข้อมูล User" ไม่ใช่แค่ true/false)
    const loggedInUser = await login(username, password); 
    
    setIsLoading(false);

    // (2. ตรวจสอบว่า Login สำเร็จหรือไม่)
    if (loggedInUser) { 
      // (3. ตรวจสอบ Role)
      if (loggedInUser.role === 'admin') {
        navigate('/admin'); // (ถ้าเป็น Admin ให้ไปหน้า Admin)
      } else {
        navigate('/'); // (ถ้าเป็น User ธรรมดา ให้ไปหน้าหลัก)
      }
    }
    // (ถ้าไม่สำเร็จ AuthContext จะแสดง toast.error เอง)
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-xl">
        
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <img 
              src="/images/logo.png" // (*** เปลี่ยน PATH ตรงนี้ ***)
              alt="RYS Customs KB Logo" 
              className="w-32 h-32 object-contain" // (ปรับขนาดตามต้องการ)
            />
          </div>
          <h2 className="text-3xl font-bold text-gray-800">
            Rayong Shipping Co., Ltd.
          </h2>
          <h2 className="mt-2 text-2xl font-bold text-gray-800">
            ระบบคลังความรู้
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            กรุณาเข้าสู่ระบบสำหรับพนักงาน
          </p>
        </div>
        
        <form className="space-y-6" onSubmit={handleSubmit}>
          
          <div>
            <label 
              htmlFor="username" 
              className="text-sm font-medium text-gray-700"
            >
              Username
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full px-4 py-3 mt-1 text-lg border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              placeholder="Username"
            />
          </div>
          
          <div>
            <label 
              htmlFor="password" 
              className="text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 mt-1 text-lg border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              placeholder="Password"
            />
          </div>

          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="w-full px-4 py-3 font-semibold text-xl text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-gray-400"
            >
              {isLoading ? 'กำลังตรวจสอบ...' : 'เข้าสู่ระบบ'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;